module.exports = __webpack_public_path__ + "static/img/1-2.ce8861e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/1-2.png
// module id = 0DsF
// module chunks = 0